import React from 'react';
import { Route, Switch } from 'react-router-dom';

import ChannelList from './components/ChannelList';
import ChannelForm from './containers/ChannelForm';
import Events from './containers/Events';
import EventEditor from './containers/EventEditor';
import AdminEvent from './components/AdminEvent';
import ChannelMessages from './components/ChannelMessages';
import Inbox from './Inbox/Inbox';
import SentMessages from './Inbox/SentMessages';

const ChannelAdmin = ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}/`} component={ChannelList} />
    <Route exact path={`${match.url}/editor`} component={ChannelForm} />
    <Route exact path={`${match.url}/events`} component={Events} />
    <Route exact path={`${match.url}/eventEditor`} component={EventEditor} />
    <Route exact path={`${match.url}/adminEvent`} component={AdminEvent} />
    <Route exact path={`${match.url}/messages`} component={ChannelMessages} />
    <Route exact path={`${match.url}/inbox`} component={Inbox} />
    <Route exact path={`${match.url}/inbox/sent`} component={SentMessages} />
  </Switch>
);

export default ChannelAdmin;

export * from './modules/actions';
export * from './modules/reducer';
